import type { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

interface MainLayoutProps {
  children?: ReactNode;
}

const MainLayout: FC<React.PropsWithChildren<MainLayoutProps>> = ({ children }) => {
  return <div className="main-layout-root">{children || <Outlet />}</div>;
};

export default MainLayout;
